module.exports = __webpack_public_path__ + "img/email.5e87d18.png";